var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "NextReviewerModal",
    {
      ref: "modal",
      attrs: { asyncSelectOptions: _vm.getNextReviewerOptions },
      on: { onOkClick: _vm.save },
    },
    [
      _c("template", { slot: "add-text" }, [
        _vm.reviewHistories.length
          ? _c("dl", { staticClass: "tip" }, [
              _c("dt", { staticClass: "tip__text font-bold" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("tenantProjects.submission.prevReviewerList")
                    ) +
                    ":\n      "
                ),
              ]),
              _vm._v(" "),
              _c("dd", [
                _c(
                  "ul",
                  _vm._l(_vm.reviewHistories, function (item, index) {
                    return _c("li", { key: index, staticClass: "tip__text" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("reviewedBy", [item.displayName, item.date])
                          ) +
                          "\n          "
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }